import { Injectable } from '@angular/core';
@Injectable()
export class GlobalStorage {
    constructor() { }

    get_user_id() {
        return sessionStorage.getItem('user_id');
    }
    get_user_name() {
        return sessionStorage.getItem('user_name');
    }
    get_user_type() {
        return sessionStorage.getItem('user_type');
    }
    get_member_id() {
        return sessionStorage.getItem('member_id');
    }
}